export const GET_ADVENTURE_REQUEST = "GET_ADVENTURE_REQUEST"
export const GET_ADVENTURE_SUCESS = "GET_ADVENTURE_ERROR"
export const GET_ADVENTURE_ERROR = "GET_ADVENTURE_ERROR"

export const ADD_ADVENTURE_REQUEST = "ADD_ADVENTURE_REQUEST"